import React from 'react';
import PropTypes from 'prop-types';
import css from './SearchBox.scss';

export const PanelSection = ({ title, children }) => (
  <div className={css.searchbox__section}>
    {title && <h4>{title}</h4>}
    <ul>{children}</ul>
  </div>
);

PanelSection.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
};
